import { NonConformityTypeModel } from '../models/non-conformity-type';

export class NonConformityTypeAdapter {
  static fromApi(data: any): NonConformityTypeModel {
    return {
      title: data.title,
      key: data.key,
    };
  }
}
